import React from "react";
import styled from "styled-components";
import { questionDifficulties } from "../document-processing/mathBankQuestionOptions";

const difficultyColors = {
  U: {
    text: "#475569", background: "#f1f5f9", border: "#cbd5e1",
    nightText: "#e2e8f0", nightBackground: "#334155", nightBorder: "#64748b",
  },
  C: {
    text: "#166534", background: "#dcfce7", border: "#86efac",
    nightText: "#bbf7d0", nightBackground: "#143b29", nightBorder: "#287a46",
  },
  B: {
    text: "#1d4ed8", background: "#dbeafe", border: "#93c5fd",
    nightText: "#bfdbfe", nightBackground: "#1e3a5f", nightBorder: "#3b6da8",
  },
  A: {
    text: "#9a3412", background: "#ffedd5", border: "#fdba74",
    nightText: "#fed7aa", nightBackground: "#542c16", nightBorder: "#b76b37",
  },
  S: {
    text: "#6b21a8", background: "#f3e8ff", border: "#d8b4fe",
    nightText: "#e9d5ff", nightBackground: "#3f225c", nightBorder: "#8753b2",
  },
};

const normalizeDifficulty = (difficulty) =>
  String(difficulty ?? "").trim().toUpperCase() || "U";

export const getQuestionDifficultyLabel = (difficulty) => {
  const value = normalizeDifficulty(difficulty);
  return questionDifficulties.find((item) => item.value === value)?.label || `${value} 難度`;
};

export default function QuestionDifficultyBadge({ difficulty, className }) {
  const value = normalizeDifficulty(difficulty);
  const label = getQuestionDifficultyLabel(value);

  return (
    <Badge
      className={className}
      $colors={difficultyColors[value] || difficultyColors.U}
      data-difficulty={value}
      aria-label={`難易度：${label}`}
    >
      {label}
    </Badge>
  );
}

const Badge = styled.span`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: fit-content;
    min-height: 24px;
    padding: 2px 8px;
    border: 1px solid ${({ $colors }) => $colors.border};
    border-radius: 999px;
    background: ${({ $colors }) => $colors.background};
    color: ${({ $colors }) => $colors.text};
    font-size: inherit;
    font-weight: 800;
    line-height: 1.4;
    vertical-align: middle;
    white-space: nowrap;
  }

  [data-auth-theme="night"] && {
    border-color: ${({ $colors }) => $colors.nightBorder};
    background: ${({ $colors }) => $colors.nightBackground};
    color: ${({ $colors }) => $colors.nightText};
  }
`;
